<template>
  <div>
    <CRow>
      <CCol sm="12">
        <AwardExchangesTable :items="awards" hover striped border small fixed caption="Premios Canjeados (Compras)"
          @refresh="refreshItems" :permissions="permissions" />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import AwardExchangesTable from '../../components/awards/AwardExchangesTable.vue'
import ws from '../../services/awards';
import account_ws from '../../services/account';
import store from '../../store'

export default {
  name: 'AwardExchanges',
  components: { AwardExchangesTable },
  data: function () {
    return {
      awards: [],
      permissions: []
    }
  },
  mounted: async function () {
    this.loading();
    let response = await ws.getExchanges();

    if (response.type == "success") {
      this.awards = response.data;
    }

    let response2 = await account_ws.getInfo();

    if (response2.type == "success") {
      this.permissions = response2.data.user.permissions;
    }

    this.loaded();
  },
  methods: {
    async refreshItems(items) {
      this.loading();
      this.awards = await items;
      this.loaded();
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  }
}
</script>
